module.exports = __webpack_public_path__ + "media/images/lp/industries/mv_realestate-d992cb18bb7bde35459eb34ddbde7178.png";